import { Translate } from 'hooks/use-translation';

/** Query param the backend should set when redirecting to `/login` after Google SSO failure. */
export const SSO_LOGIN_ERROR_QUERY_PARAM = 'sso_error';

/**
 * Maps backend `sso_error` codes to user-facing copy.
 */
export function getLoginSsoCallbackErrorMessage(
  code: string,
  translate: Translate<string>,
): string {
  switch (code) {
    case 'USER_NOT_FOUND':
      return translate('login.sso_callback_error_user_not_found');
    case 'SESSION_EXPIRED':
      return translate('login.sso_callback_error_session_expired');
    default:
      return translate('login.sso_callback_error_generic');
  }
}
